class UsageUnit {
    static Miles : string = "miles";
    static Kilometres : string = "kilometres";
    static ActiveAssets : string = "activeAssets";
}

export { UsageUnit }